import { useCallback, useEffect, useState } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { WalletOffer } from "@hopper-b2b/types";
import { ButtonWrap, Divider } from "@hopper-b2b/ui";
import clsx from "clsx";
import Chevron from "../../../assets/client/chevron.svg?react";
import Coin from "../../../assets/client/coin.svg";
import { FintechBanner } from "../../FintechBanner";
import { FintechHalfSheet } from "../../FintechHalfSheet";
import { HotelOfferTermsModal } from "../../TermsAndConditionsWrapper/component";
import styles from "./styles.module.scss";

interface HotelVoucherOfferBannerProps {
  isEligible: boolean;
  showMore: boolean;
  offers?: WalletOffer[];
  minimal?: boolean;
  onClick?: () => void;
  title?: string;
}

export const HotelVoucherOfferBanner = ({
  isEligible,
  showMore,
  offers,
  minimal = false,
  onClick,
  title,
}: HotelVoucherOfferBannerProps) => {
  const { t } = useI18nContext();
  const [openHalfSheet, setOpenHalfSheet] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const [offer, setOffer] = useState<WalletOffer>(null);
  const offerTitle: string =
    title || offer?.offerContent.title || offer?.offerContent.name || "";

  useEffect(() => {
    if (offers) {
      setOffer(offers[0]);
    }
  }, [offers]);

  const handleOpenHalfSheet = useCallback(() => {
    onClick && onClick();
    setOpenHalfSheet(true);
  }, [onClick]);

  const handleCloseHalfSheet = useCallback(() => {
    setOpenHalfSheet(false);
  }, []);

  return isEligible && offer ? (
    <>
      <FintechBanner
        title={offerTitle}
        subtitle={!minimal ? t("hotelVoucherSubtitle") : null}
        fintechIcon={Coin}
        hideBrand
        className={clsx(
          styles.HotelVoucherOfferBanner,
          "HotelVoucherOfferBanner",
          minimal ? "minimal" : null
        )}
        onClick={showMore ? handleOpenHalfSheet : null}
      />
      {showMore && offer ? (
        <>
          <FintechHalfSheet
            className={clsx(
              styles.HotelVoucherOfferModal,
              "HotelVoucherOfferModal"
            )}
            isOpen={openHalfSheet}
            onClose={handleCloseHalfSheet}
            icon={Coin}
            title={offerTitle}
            description={
              <div>
                {offer.offerContent.restrictions ||
                offer.offerContent.termsAndConditions ? (
                  <p className={styles.HotelVoucherOfferFinePrint}>
                    {t("offersCancellationDisclosure")}
                  </p>
                ) : null}
                <p className={styles.HotelVoucherOfferFinePrint}>
                  {offer.offerContent.restrictions ||
                    offer.offerContent.termsAndConditions}
                </p>
                <Divider />
                <ButtonWrap
                  className={styles.HotelVoucherTermButton}
                  onClick={() => setOpenTermsModal(true)}
                >
                  <p className={styles.HotelVoucherTerms}>
                    {t("termsAndConditions")}
                  </p>
                  <Chevron />
                </ButtonWrap>
              </div>
            }
          />
          <HotelOfferTermsModal
            openModal={openTermsModal}
            setOpenModal={setOpenTermsModal}
          />
        </>
      ) : null}
    </>
  ) : null;
};
